import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { PermissionService } from 'app/@core/services/permission.service';
import { Global } from 'app/@core/lib/global';
import { TranslateService } from '@ngx-translate/core';
import { SysService } from 'app/services/sys.service';
@Component({
    selector: 'app-lobby',
    templateUrl: './lobby.component.html',
    styleUrls: ['./lobby.component.scss'],
    providers: [PermissionService, TranslateService, SysService]
})

export class LobbyComponent {

    public menu: any;
    public settings: any;

    constructor(
        public router: Router,
        public permissionService: PermissionService,
        public sysService: SysService,
        public global: Global
    ) {
        let menu = window.location.pathname;

        console.log('[LobbyComponent] path', menu);

        this.sysService.menu().then((response) => {
            this.permissionService.filterSideBar(response.data, this.global.loggedUser().id)
                .then(res => {
                    console.log("SidebarComponent: checkRoles", res);
                    let menuItems = res;
                    console.log('[LobbyComponent] menu:', menuItems);
                    let sub = menuItems.find(m => m.path == menu);
                    console.log('[LobbyComponent] sub:', sub);
                    if (sub) {
                        this.menu = sub;
                        this.settings = sub.children.map(item => {
                            if (this.global.loggedUser().client_id == 4) {
                                if (item.path == 'videos/folders') {
                                    item.path = '/videos/folders';
                                    item.type = 'sub-app';
                                }
                            }
                            return item;
                        });
                        
                        if (menu === '/cadastros' && this.global.loggedUser().client_id == 20) {
                            this.settings.push({
                                path: 'usuarios-smart',
                                role: 'usuarios',
                                title: 'Apontamento de Contas',
                                ab: 'AC',
                                description: 'Gerencie as contas e acessos do ambiente Smart.',
                                link: 'Configurar'
                            });
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                })
        });

    }
}



// WEBPACK FOOTER //
// ./src/app/shared/lobby/lobby.component.ts